import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="appointment-footer-client">
      <div className="vs-appt-footer">
        <div className="vs-appt-footer-links">
          <Link to="/terms-conditions">Terms &amp; Conditions</Link>
          <span className="vs-appt-footer-divider" aria-hidden="true" />
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
        <p className="vs-appt-footer-copy">
          &copy; 2022 Very Soul LLC. All rights reserved.
        </p>
        <p className="vs-appt-footer-note">
          <strong>Note:</strong> For optimum performance: use Chrome, Safari, or
          Edge browser
        </p>
        <p className="vs-appt-footer-support">
          Have a question?{" "}
          <a
            href={process.env.REACT_APP_SUPPORT_URL}
            target="_blank"
            rel="noreferrer"
          >
            Submit Support Ticket
          </a>
        </p>
      </div>
    </div>
  );
}
